function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { NotificationDeliveryWindow } from '../enums/notification-delivery-window';
import { StatusType } from '../enums/status-type';
import { DeliveryChannel } from '../interfaces/notification-channels';
import { Platform } from '@pushly/cuttlefish';
export function isNotificationScheduleUsingStzDelivery(schedule) {
  var _schedule$deliverySpe;

  return ((_schedule$deliverySpe = schedule.deliverySpec) === null || _schedule$deliverySpe === void 0 ? void 0 : _schedule$deliverySpe.window) === NotificationDeliveryWindow.TIMEZONE;
}
export function isNotificationScheduleStzDeliveryInProgress(schedule, statusId) {
  return isNotificationScheduleUsingStzDelivery(schedule) && statusId === StatusType.DELIVERING;
}
export var buildPreviewOptions = function buildPreviewOptions(channels) {
  var optSet = new Set([]);

  for (var channel in channels) {
    if (channels[channel]) {
      var enabledChannel = channel.toUpperCase();

      if (DeliveryChannel[enabledChannel] === DeliveryChannel.WEB) {
        optSet.add({
          value: Platform.ANDROID,
          label: 'Android'
        });
        optSet.add({
          value: Platform.WINDOWS,
          label: 'Web / Windows'
        });
        optSet.add({
          value: Platform.MAC_OS,
          label: 'MacOS'
        });
      }

      if (DeliveryChannel[enabledChannel] === DeliveryChannel.NATIVE_ANDROID && !channels[DeliveryChannel.WEB]) {
        optSet.add({
          value: Platform.ANDROID,
          label: 'Android'
        });
      }

      if (DeliveryChannel[enabledChannel] === DeliveryChannel.NATIVE_IOS) {
        optSet.add({
          value: Platform.IOS,
          label: 'Apple / iOS'
        });
      }
    }
  }

  return _toConsumableArray(optSet.values());
};